export default "__VITE_ASSET__phKSlgOm__"